/* options for all validators, parent interface */
export interface ValidatorOptions {
  errorName?: string;
}
